import {
    CREATE_PRODUCT,
} from "../actions";

const product = (state = [], action) => {
    switch (action.type) {
    case CREATE_PRODUCT:
        return {
            id: action.id,
            name: action.name,
            amount: action.amount,
            packageId: action.packageId,
            packageCode: action.packageCode,
            productCode: action.productCode,
            contractTermId: action.contractTermId,
            contractTermDiscountType: action.contractTermDiscountType,
            discountPercentage: action.contractTermDiscountPercentage,
            contractTermDiscountPeriods: action.contractTermDiscountPeriods,
            discountDescription: action.discountDescription,
            language: action.language,
            wizardType: action.wizardType
        };
    default:
        return state
    }
}

export default product;